/**
 * Los documentos que le corresponden a un perfil.
 *
 * Los documentos de una convocatoria vienen marcados con tipo_persona —0
 * natural, 1 jurídica, 2 grupo conformado— y cada perfil solo ve los suyos.
 * La misma regla la usan los avisos y la pantalla del segundo paso, que la
 * necesita para saber si una columna va a quedar vacía.
 */

/**
 * Sin perfil no se filtra nada. Un documento sin tipo_persona se deja pasar:
 * no hay con qué descartarlo, y callar un documento que sí aplica es peor
 * que mostrar uno de más.
 */
export const documentosDelPerfil = (documentos: any, tipoPersona?: number | null): any[] => {
  const lista = Array.isArray(documentos) ? documentos : [];
  if (tipoPersona === null || tipoPersona === undefined) return lista;

  return lista.filter((documento: any) => {
    const suyo = documento?.tipo_persona;
    if (suyo === null || suyo === undefined || suyo === "") return true;
    return Number(suyo) === Number(tipoPersona);
  });
};

/** El perfil contando desde cero, como lo guardan los documentos. */
export const perfilParaDocumentos = (tipoParticipante: any): number | null => {
  const elegido = Number(tipoParticipante);
  return Number.isFinite(elegido) && elegido > 0 ? elegido - 1 : null;
};
